 document.addEventListener("DOMContentLoaded", function() {
 // Force close menu behavior
  document.addEventListener('click', function(e) {
    // Check if the clicked element is close button or inside it
    if (e.target.closest('[data-menu-close]')) {
      e.preventDefault();
      
      const menu = document.querySelector('component-menu');
      const overlay = document.querySelector('[data-menu-overlay]');
      const body = document.body;

      if (menu) {
        // Remove active class to start animation out
        menu.classList.remove('active');
        
        // Remove active-submenu class
        menu.classList.remove('active-submenu');

        // Immediately hide overlay to give feedback
        if (overlay) {
             overlay.classList.add('opacity-0');
             setTimeout(() => {
                 if(!menu.classList.contains('active')) {
                    overlay.classList.add('hidden');
                 }
             }, 300);
        }

        // Restore body scroll
        body.style.removeProperty('overflow');

        // Force hide menu after transition time (adjust 500ms to match your CSS transition)
        setTimeout(function() {
          if (!menu.classList.contains('active')) {
            menu.classList.add('hidden');
            menu.setAttribute('aria-hidden', 'true');
          }
        }, 300); // 300ms matches standard transition often used
      }
    }
  });

    // Fix for Android submenu opening
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-menu-submenu-target]');
    if (trigger) {
       // Get the target ID
       const targetName = trigger.getAttribute('data-menu-submenu-target');
       const submenu = document.querySelector(`[data-menu-submenu="${targetName}"]`);
       
       if (submenu && !submenu.classList.contains('active')) {
           e.preventDefault();
           e.stopPropagation(); // Stop bubbling to prevent conflicts
           
           // Open submenu manually
           submenu.classList.remove('hidden');
           submenu.setAttribute('aria-hidden', 'false');
           
           // Handle chevron rotation if exists
           const chevron = trigger.querySelector('.icon-chevron');
           if (chevron) {
               chevron.classList.add('rotate-180');
           }

           // Animation delay
           setTimeout(() => {
               submenu.classList.add('active');
               submenu.classList.add('animation'); 
               
               // Ensure overlay is visible
               const overlay = document.querySelector('[data-menu-overlay]');
               if (overlay) {
                   overlay.classList.remove('hidden');
                   setTimeout(() => overlay.classList.remove('opacity-0'), 50);
               }
           }, 10);
       }
    }
  });

  });
  window.addEventListener('variant-change', function(event) {
  const variant = event.detail.variant;
  if (!variant || !variant.featured_image) return;

  // Find the Swiper instance on the product page
  const swiperEl = document.querySelector('.product-media__images');
  if (!swiperEl || !swiperEl.swiper) return;

  // Match the variant's image src to a slide and jump to it
  const targetSrc = variant.featured_image.src;
  const slides = swiperEl.querySelectorAll('.swiper-slide');

  slides.forEach(function(slide, index) {
    const img = slide.querySelector('img');
    if (img && img.src && img.src.includes(targetSrc.split('?')[0].split('/').pop().split('.')[0])) {
      swiperEl.swiper.slideTo(index);
    }
  });
});

// Fix: video slides off-screen due to autoHeight Swiper miscalculation
function fixProductMediaSwiper() {
  var mediaEl = document.querySelector('product-media');
  if (mediaEl && mediaEl.swiper) {
    mediaEl.swiper.update();
    mediaEl.swiper.slideTo(0, 0);
    return true;
  }
  return false;
}

document.addEventListener('DOMContentLoaded', function() {
  var attempts = 0;
  var interval = setInterval(function() {
    attempts++;
    if (fixProductMediaSwiper() || attempts > 20) {
      clearInterval(interval);
    }
  }, 100);
});